import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();

document.addEventListener(
  "click",
  function(event) {
    if (!event.target.matches(".vacancy-header__read-more")) return;

    event.preventDefault();

    const content = document.querySelector("#content");

    if (content === null) {
      return;
    }

    window.scrollTo({ top: content.offsetTop - 100, behavior: "smooth" });
  },
  false
);
